@if (advancedSearchConfig) {
<div class="advanced-search">
    <section class="mat-typography">
        <h2>{{ advancedSearchConfig.title }}</h2>
    </section>
        @if (advancedSearchConfig.showDateRange) {
<ng-container [formGroup]="datesForm">
            <div>
                <div class="date-container mauto">
                    <tools-date-time
                        [providedDate]="datesForm.controls['startDateControl'].value"
                        [label]="'Start Date'"
                        (notify)="updateStartDateTime($event)">
                    </tools-date-time>
                </div>
                <div class="date-container mauto">
                    <tools-date-time
                        [providedDate]="datesForm.controls['endDateControl'].value"
                        [label]="'End Date'"
                        (notify)="updateEndDateTime($event)">
                    </tools-date-time>
                </div>
            </div>
        </ng-container>
}
        <div class="form-fields-container">
            <div>
                <mat-form-field style="width: 100%;">
                    <mat-label>{{ advancedSearchConfig.fuzzySearchLabel }}</mat-label>
                    <input matInput (keydown.enter)="submit()" [formControl]="fuzzyControl">
                </mat-form-field>
            </div>
            <ng-container [formGroup]="advancedSearchForm">
                @for (field of advancedSearchConfig.formControls; track field) {
<div>
                    <mat-form-field style="width: 100%;">
                        <mat-label>{{ field.label ? field.label : field.controlName }}</mat-label>
                        @if (field.type == 'text') {

                            <input matInput (keydown.enter)="submit()" [formControlName]="field.controlName">
                        
}
                        @if (field.type == 'number') {

                            <input matInput (keydown.enter)="submit()" type="number" [formControlName]="field.controlName">
                        
}
                        @if (field.type == 'dropDown') {

                            <mat-select [formControlName]="field.controlName" [multiple]="field.allowMultipleSelect">
                                <div style="margin: 0 17px">
                                    <mat-form-field floatLabel="always" style="width: 100%;">
                                        <mat-label>Search</mat-label>
                                        <input placeholder="Search..." matInput [formControl]="dropDownSearchControls[field.controlName]">
                                    </mat-form-field>
                                </div>
                                @if (field.allowMultipleSelect) {
<mat-checkbox color="primary" class="select-all" [formControl]="allSelectedInDropDowns[field.controlName]" (change)="setAll(field.controlName)">All</mat-checkbox>
}
                                @for (option of filteredDropDownValues[field.controlName] | async; track option) {
<mat-option [value]="option.value">{{ option.label }}</mat-option>
}
                            </mat-select>
                        
}
                        @if (field.icon) {
<mat-icon matSuffix>{{ field.icon }}</mat-icon>
}
                        @if (field.hint) {
<mat-hint>{{ field.hint }}</mat-hint>
}
                    </mat-form-field>
                </div>
}
            </ng-container>
        </div>
        <div class="buttons-wrapper">
            <button mat-raised-button  type="submit" (click)="submit()"><mat-icon class="mg-r-10">search</mat-icon>Search</button>
            <button mat-raised-button (click)="reset()"><mat-icon class="mg-r-10">clear</mat-icon>Reset to defaults</button>
        </div>

        @if (!firstSearch) {
<div style="margin-top: 30px;">{{ searchReminderText }}</div>
}
</div>
}
